import { render } from "./Settings.vue?vue&type=template&id=56b23782&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=56b23782&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56b23782"

export default script